import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BackendApiService } from '../../../../app/services/backend-api.service';
import { Router } from '@angular/router';
import { BaseUrlConstantsService } from '../../../../app/services/base-url-constants.service';
import { PiezeoService } from '../../../../app/services/piezeo.service';
import { PiezeoDashboardService } from '../../../../app/services/piezo-dashboard.service';

interface Sensor {
  x: number;
  y: number;
  subType: string;
  assetType: string;
  associated: boolean;
  configured: boolean;
  gateway_id: number;
  no_of_axis: number;
  assetMarker: string;
  xPercentage: number;
  yPercentage: number;
  sensorDNames: string;
  sensorMarker: string;
  sensors_info: any;
  xPercentages: number;
  yPercentages: number;
  sensor_number: number;
  xPercentageNet: number;
  yPercentageNet: number;
  form_configured: boolean;
  temperature_channel: number;
  is_temperature_added: number;
  color?: string;
  asset_status?: number;
  health:string,
  device_status:number,
  master_type:number
  mac_address:string,
  serial_number:string,
}

interface Asset {
  id: number;
  subsystem_uuid: string;
  template_id: number | null;
  subsystem_type: string;
  subsystem_name: string;
  site_id: number | null;
  application_id: number | null;
  client_id: number;
  Image_path: string;
  device_position: string;
  created_at: string;
  updated_at: string;
  out_for_service: number;
  display_order: number | null;
  commission_date: string | null;
  axis: number | null;
  sensors?: Sensor[];
  overall_health?: string;
  overall_live_status?: number;
}

@Component({
  selector: 'app-piezo-cards',
  templateUrl: './piezo-listing.component.html',
  styleUrls: ['./piezo-listing.component.scss'],
  standalone:true,
  imports:[FormsModule,CommonModule]
})
export class PiezoCardsComponent implements OnInit {

  client_id:number=null;

  assetList: Asset[] = [];
  filteredAssetList: Asset[] = [];
  assetLoader: boolean = false;

  // Filter states
  selectedSites: string[] = ['All Sites'];
  selectedApplications: string[] = ['All Applications'];
  selectedAssets: string[] = ['All Assets'];

  // View mode
  viewMode: 'assets' | 'cylinder' = 'assets';

  // Menu state
  openMenuIndex: number | null = null;
  // url_prefix='https://qaapi.enertics.ca/piezo_service'
  url_prefix=`${BaseUrlConstantsService.BASE_PIEZO_SERVICE}`
  // url_prefix='http://localhost:3017'

  constructor(
    private srv:BackendApiService,
    private router:Router,
    private piezo_srv:PiezeoDashboardService
  ) {}

  ngOnInit(): void {
    let role=localStorage.getItem('role')

    switch(role){
      case "CLIENT":
        this.client_id=parseInt(localStorage.getItem('user_id'));
        break;
    }

    this.fetchAssetsForClient();
  }

  fetchAssetsForClient(): void {
    this.assetLoader = true;
    this.srv.getDataV2(`${this.url_prefix}/api/get-subsystems/${this.client_id}`)
      .then(res => {
        this.assetLoader = false;
        const response = JSON.parse(JSON.stringify(res));
        if (response.code === 200) {
          this.processAssetData(response);
        }
      })
      .catch(error => {
        console.error('Error fetching assets:', error);
        this.assetLoader = false;
      });

  }

  processAssetData(response: any): void {
    this.assetList = response.data.map((asset: Asset) => {
      let parsedSensors: Sensor[] = [];
      try {
        parsedSensors = JSON.parse(asset.device_position);
        // Assign random colors and statuses for demo purposes
        parsedSensors = parsedSensors.map(sensor => ({
          ...sensor,
          color: sensor.color,
          asset_status: sensor.device_status
        }));
      } catch (error) {
        console.error('Error parsing device_position:', error);
      }
      return {
        ...asset,
        sensors: parsedSensors,
        overall_health: asset.overall_health,
        overall_live_status: asset.overall_live_status
      };
    });
    console.log(this.assetList)

    this.filteredAssetList = [...this.assetList];
  }

  getRandomColor(): string {
    const colors = ['gray', 'gray', 'gray'];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  toggleMenu(event: Event, index: number): void {
    event.stopPropagation();
    this.openMenuIndex = this.openMenuIndex === index ? null : index;
  }

  closeMenu(): void {
    this.openMenuIndex = null;
  }

  editAsset(event: Event, asset: Asset, index: number): void {
    event.stopPropagation();
    this.closeMenu();
    this.router.navigate(['/piezeo-edit', asset]);
  }

  deleteAsset(event: Event, asset: Asset, index: number): void {
    event.stopPropagation();
    this.closeMenu();

    if (confirm(`Are you sure you want to delete "${asset.subsystem_name}"?`)) {
      this.assetLoader = true;
      this.srv.deleteInfo(`${this.url_prefix}/api/delete-subsystem/${asset.id}/${this.client_id}`)
      .then(res => {
        this.assetLoader = false;
        const response = JSON.parse(JSON.stringify(res));
        if (response.code === 200 || response.status === 'success') {
          // Remove asset from lists
          this.assetList = this.assetList.filter(a => a.id !== asset.id);
          this.filteredAssetList = this.filteredAssetList.filter(a => a.id !== asset.id);
          this.srv.showSuccess('Asset deleted successfully');
        } else {
            this.srv.showError('Failed to delete asset');
          }
        })
        .catch(error => {
          console.error('Error deleting asset:', error);
          this.assetLoader = false;
          alert('Error deleting asset. Please try again.');
        });
      }
  }

  openAssetDetails(index: number): void {
    this.piezo_srv.setSubsystemData(this.filteredAssetList[index]);
    this.router.navigate(['/piezo-dashboard', this.filteredAssetList[index]]);
  }

  showTooltip(sensor: Sensor): string {
    const {subType,sensorDNames,assetType,gateway_id,master_type,mac_address:mac,serial_number:serial}=sensor;
    let sub_type=assetType=='MOTOR'?`Sub-Type: ${subType}`:'';
    let type=`Type: ${assetType}`;
    let display_name=`Sensor: ${sensorDNames}`
    let marker=`Marker: ${sensor.assetMarker}`
    let master__type=master_type==4?`Master-Type: Piezo`:master_type==3?`Master-Type: EmStd + RTDs`:master_type==2?`Master-Type: Em-Standard`:'Master-Type: Em-Mini';
    let mac_address=`MAC: ${mac}`
    let serial_number=`Serial: ${serial}`
    return `
      ${display_name}
      ${type}
      ${sub_type}
      ${marker}
      ${master__type}
      ${mac_address}
      ${serial_number}

    `;
  }

  getStatusLabel(status: number|string): string {
    switch (status) {
      case '0':
      case 0:
      case '2':
      case 2:
        return 'Asset Idle';
      case '1':
      case 1:
        return 'Asset Running';
      default:
        return 'Unknown';
    }
  }

  getStatusColor(status: string): string {
    status+=''
    switch (status) {
      case '0':
      case '2':
        return '#dbccbf';
      case '1':
        return '#3fbddd';
      default:
        return '#999';
    }
  }
}
